<template>
    <div class="useful-services-block useful-services__block">
        <div class="useful-services-block__title">
            <span class="useful-services-block__rates">
                Курсы валют
            </span>
        </div>
        <template v-if="internetRates && internetRates.length">
            <div
                :class="[
                    'useful-services-block__content',
                    'useful-services-block__content_color',
                    'useful-services-block__content_flex',
                    'useful-services-block__content--temp',
                ]"
            >
                <h4 class="h4 mb-8">В Головном офисе банка*</h4>
                <div class="useful-services-block__row">
                    <h6 class="useful-services-block-row__title useful-services-block-row__title_arrow">
                        валюта
                    </h6>
                    <h6 class="useful-services-block-row__title">покупка</h6>
                    <h6 class="useful-services-block-row__title">продажа</h6>
                </div>
                <div
                    v-for="({currencyCode, sellRate, buyRate, buyRateChange, sellRateChange}, index)
                        in officeCurrencies"
                    :key="currencyCode + sellRate + index"
                    class="useful-services-block__row"
                >
                    <h6 class="useful-services-block-row__title useful-services-block-row__title_currency">
                        {{ getReadableCurrencyCode(currencyCode) }}
                    </h6>
                    <p
                        :class="[
                            'useful-services-block-row__value',
                            `useful-services-block-row__value--${buyRateChange}`
                        ]"
                    >
                        {{ buyRate.toFixed(2) }}
                    </p>
                    <p
                        :class="[
                            'useful-services-block-row__value',
                            `useful-services-block-row__value--${sellRateChange}`
                        ]"
                    >
                        {{ sellRate.toFixed(2) }}
                    </p>
                </div>
            </div>
            <p class="useful-services-block__info">
                Актуально на {{ actualDate }}
                <nuxt-link
                    class="step-link"
                    to="/for-individuals/currency-rates"
                >
                    Посмотреть все курсы.
                </nuxt-link>
            </p>
            <p class="useful-services-block__info useful-services-block__info--description">
                *Операции продажи и&nbsp;покупки наличной иностранной валюты у&nbsp;физических
                лиц осуществляются только в&nbsp;офисе по&nbsp;адресу&nbsp;г. Ростов-на-Дону, Соколова,
                62&nbsp;в рабочие дни (с&nbsp;понедельника по&nbsp;пятницу) с&nbsp;09:00 до&nbsp;19:00
            </p>
        </template>
        <template v-else>
            <h3 class="h3">Извините. Курсы валют временно не доступны!</h3>
        </template>
    </div>
</template>

<script>
import {defineComponent, computed} from 'vue';
import {useFetch} from '@nuxtjs/composition-api';

import {useCurrencyRatesStore} from '@/stores/currency-rates';
import {datePlugin} from '@/core/plugins/dates';
import CURRENCIES from '@/core/constants/currency';

export default defineComponent({
    name: 'CurrencyRatesTableSmallTemp',
    setup() {
        const currencyRatesStore = useCurrencyRatesStore();
        const internetRates = computed(() => currencyRatesStore.internetRates);
        const mainPageRates = computed(() => currencyRatesStore.mainPageRates);
        const {getInternetRates, getOfficeRates} = currencyRatesStore;

        const actualDate = computed(() => {
            return datePlugin().format('DD.MM.YYYY HH:mm');
        });
        const officeCurrencies = computed(() => {
            return mainPageRates.value?.reduce((acc, item) => {
                const key = getReadableCurrencyCode(item.currencyCode)?.toLowerCase();
                if (getReadableCurrencyCode(item.currencyCode) && CURRENCIES.CURRENCY_NAMES[key]) {
                    const changedItem = Object.assign({}, item, {
                        code: getReadableCurrencyCode(item.currencyCode),
                    });

                    acc.push(changedItem);
                }

                return acc;
            }, []) ?? [];
        });

        function getReadableCurrencyCode(currencyCode) {
            const [code, additionalCode] = currencyCode.split('/');

            if (additionalCode?.toLowerCase() === 'rub' || !additionalCode?.toLowerCase()) {
                return code;
            }
        }

        useFetch(async() => {
            !internetRates.value?.length && await getInternetRates();
            !mainPageRates.value?.length && await getOfficeRates();
        });

        return {
            internetRates,
            actualDate,
            officeCurrencies,
            getReadableCurrencyCode,
        };
    },
});
</script>

<style lang="scss">
    @import '@/assets/styles/components/home-page/index/services';
</style>

<style lang="scss" scoped>
    .useful-services-block__content {
        &--temp {
            padding: 32px 56px;

            @media (width <= 540px) {
                padding: 20px 18px;
            }
        }

        &__text {
            font-size: 16px;
            margin-top: 8px;
        }
    }
</style>
